// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mdl-product-listing[data-v-5a8d5928]{scroll-margin-top:calc(var(--header-height) + 60px)}", ""]);
// Exports
module.exports = exports;
